import UserAPI from '../../api/UserAPI';

export function testStringIsEmpty(text){
 var userText = text;
userText = userText.replace(/^\s+/, '').replace(/\s+$/, '');
if (userText === '') {
   return true
    // text was all whitespace
} else {
    return false
    // text has real content, now free of leading/trailing whitespace
}
}

export function getUserInfo(popkey){
  return function(dispatch){
      dispatch({type:'GET_USER_INFO_LOADING'});
    return UserAPI.getUserInfo(popkey)
    .then(data=>{
      dispatch({type:'GET_USER_INFO',payload:data.data})
    })
    .catch((error)=>{
      console.log(error.response)
      dispatch({type:'GET_USER_INFO_ERROR'})
    })
  }
}


export function goConnectUser(email,password){

  return function(dispatch){
      dispatch({type:'GO_CONNECT_USER_LOADING'})
        return UserAPI.goConnect(email,password)
        .then((data)=>{
              if(data.data.hasOwnProperty("error")){
                  return dispatch({type:'GO_CONNECT_USER_ERROR',payload:data.data.error.type})
              }
              else{
                return dispatch({type:'GO_CONNECT_USER_SUCCESS',payload:data.data})
              }
        })
        .catch((error)=>{
          console.log(error)
          return dispatch({type:'GO_CONNECT_USER_ERROR',payload:3})
        })

  }
}


export function registerUser(
  firstName,
  lastName,
  pseudo,
  email,
  avatar,
  password,
) {
  return function(dispatch) {
    dispatch({
      type: 'REGISTER_USER_LOADING',
    });
    return UserAPI.registerUser(
      firstName,
      lastName,
      pseudo,
      email,
      avatar,
      password,
    ).then(data => {
          console.log(data.data)
          localStorage.setItem('pnc_popkey', data.data.auth_token);
          dispatch({
            type: 'REGISTER_USER_SUCCESS',
            payload:{
            info_user: data.data,
            popkey: data.data.auth_token
            }
          });

      })
      .catch(error => {
        console.log(error);
        if(error.response && error.response.data.hasOwnProperty('error') ){
        dispatch({
          type: 'REGISTER_USER_ERROR',
          payload:{
            error:error.response.data.error.details
          }
        });
        }
        else{
          dispatch({
            type: 'REGISTER_USER_ERROR',
            payload:{
              error:'Une erreur est survenue !'
            }
          });
        }
      });
  };
}




export function updatePersonalData(firstname,lastname,pseudo,popkey){
  return function(dispatch){
    dispatch({type:'UPDATE_PERSONNAL_DATA_LOADING'});
      if(testStringIsEmpty(firstname) || testStringIsEmpty(lastname) || testStringIsEmpty(pseudo)){
        dispatch({type:'UPDATE_PERSONNAL_DATA_ERROR',payload:{
          error:"Une erreur est survenue!"
        }})
    }
    else{

    return UserAPI.updatePersonnalData(firstname,lastname,pseudo,popkey)
    .then(data=>{
      dispatch({type:'UPDATE_PERSONNAL_DATA_SUCCESS',payload:
        {
          pseudo:data.data.pseudo,
          firstname:data.data.firstname,
          name:data.data.name
        }})
    })
    .catch((error)=>{
      dispatch({type:'UPDATE_PERSONNAL_DATA_ERROR',payload:{
        error:error.response.data.error.details
        }})
      })
    }
  }
}


export function updateAvatarUser(popkey,avatar){
  return function(dispatch){
      dispatch({type:'UPDATE_AVATAR_LOADING'});
        return UserAPI.updateAvatarUser(popkey,avatar)
        .then(data=>{
          console.log(data);
          dispatch({type:'UPDATE_AVATAR_SUCCESS',payload:data.data.avatar})
        })
        .catch((error)=>{
          dispatch({type:'UPDATE_AVATAR_ERROR',payload:{
            error:error.response.data.error.details
            }})
        })

  };

}

  export function updateBoatUser(popkey,immat,name,id_boat){
    return function(dispatch){
        dispatch({type:'UPDATE_BOAT_LOADING'});
          return UserAPI.updateBoatUser(popkey,immat,name)
          .then(data=>{
            console.log(data);
            dispatch({type:'UPDATE_BOAT_SUCCESS',payload:{
              boat_immatriculation:data.data.boat_immatriculation,
              boat_name:data.data.boat_name,
              id_boat:data.data.id_boat,
            }})
          })
          .catch((error)=>{
            console.log(error);
            dispatch({type:'UPDATE_BOAT_ERROR',payload:{
              error:error.response.data.error.details
              }})
          })

    }

}


export function updateAdressUser(popkey,adress){
  return function(dispatch){
      dispatch({type:'UPDATE_ADRESS_LOADING'});
        return UserAPI.updateAdress(popkey,adress)
        .then(data=>{
          console.log(data.data);
          dispatch(
            {
            type:'UPDATE_ADRESS_SUCCESS',
            payload:{
            adress_postal:data.data.adress_postal,
          }})
        })
        .catch((error)=>{
          console.log(error);
          dispatch({type:'UPDATE_ADRESS_ERROR',payload:{
            error:error.response.data.error.details
            }})
        })
  }
}
